import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {Chart, registerables} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';
import * as Sentry from '@sentry/angular';

import {AppModule} from './app/app.module';
import {chartAreaStylePlugin} from './app/pages/patient/services/graph/chart-area-style.plugin';
import {commentsIndicatorsPlugin} from './app/pages/patient/services/graph/comments-indicators.plugin';
import { ENVIRONMENT } from './environments/environment';


Chart.register(
  ...registerables,
  annotationPlugin,
  zoomPlugin,
  chartAreaStylePlugin,
  commentsIndicatorsPlugin,
);

if (ENVIRONMENT.production) {
  Sentry.init({
    dsn: 'https://e61136dd96cffa486cdc32b0a6403046@o4507622568820736.ingest.de.sentry.io/4507623117553744',
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
